import $http from '$http'
import {
    lg,
    util
} from 'utils';

export default {
    methods: {
        getInfo(options) {
            let opts = $.extend({}, this.getErpConfig(), options);
            let Params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                OrderId: opts.id
            };
            $http.get('api/BookOnlyOrder/GetBookOnlyOrderById', Params).then(res => {
                util.doResult(this, res, () => {
                    this.OrderData = res.data.Data;
                    this.auditFormData.OrderId = this.OrderData.OrderId;
                    this.auditFormData.AuditRemark = this.OrderData.AuditRemark;
                    this.getAgentBookOrderHistory(this.OrderData.AgentId)
                });
            });
        },
        //审核确定
        auditConfirm(params) {
            this.auditFormData.PayMode = this.OrderData.PayMode,
                this.auditFormData.SendMode = this.OrderData.SendMode,
                $http.post('api/BookOnlyOrder/BookOnlyOrderAuditForFinance', params).then(res => {
                    util.doResult(this, res, () => {
                        this.$notify({
                            title: '成功',
                            message: '审核成功！',
                            type: 'success'
                        });
                        this.dialogVisible = false;
                        this.$emit('reLoadData');
                    });
                });
        },
        //获取代理商已下订单信息
        getAgentBookOrderHistory(agentId) {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                AgentId: agentId
            };
            this.details = {}
            this.loading = true;
            $http.get("api/BookOnlyOrder/GetAgentBookOrderHistory", params).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                this.loading = false;
                util.doResult(this, res, () => {
                    this.details = Data;
                    this.details.area = []
                    for (let i = 0; i < this.details.AreaList.length; i++) {
                        this.details.area.push(this.details.AreaList[i].ProvName + this.details.AreaList[i].CityName + this.details.AreaList[i].AreaName)

                    }
                    this.details.area = this.details.area.join(',')

                });
            });
        },
    }
};


// WEBPACK FOOTER //
// ./src/pages/Order/orderAudit/components/paymentAuditOrder/services.js